import toArray from '../../../frontend/scripts/utils/to-array';

export default () => {
  const sections = toArray(document.querySelectorAll('.js-videos'));
  sections.forEach(section => {
    import('./Videos' /* webpackChunkName: "videos" */).then(
      ({ initializeForElement }) => {
        initializeForElement(section);
      }
    );
  });
};
